import { Tooltip } from "@mui/material"
import { InfoOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import type { Product } from "@/graphql/codegen/graphql"

interface InventoryProductDescriptionProps {
  product: Product
  className?: string
}

export const InventoryProductDescription: FC<InventoryProductDescriptionProps> = ({ product, className }) => {
  return (
    <div className={twMerge("flex flex-col gap-y-1", className)}>
      {product.companyProductDescription && (
        <div className='flex items-center gap-x-1'>
          <span className='whitespace-nowrap text-sm/[1.125rem] font-medium text-gray-900'>
            {product.companyProductDescription}
          </span>
          <Tooltip title='Akrochem Description' placement='right'>
            <InfoOutlined className='text-gray-600' fontSize='small' />
          </Tooltip>
        </div>
      )}
      {product.vendorDescription && (
        <div className='flex items-center gap-x-1 text-sm/[1.125rem]'>
          <span className='whitespace-nowrap'>{product.vendorDescription}</span>
          <Tooltip title='Supplier Description' placement='right'>
            <InfoOutlined className='text-gray-600' fontSize='small' />
          </Tooltip>
        </div>
      )}
    </div>
  )
}
